import { Router } from "@vaadin/router";

import type { Route } from "./routes";

export abstract class KioskRouter {
  static go: (path: string) => void;

  abstract setRoutes(routes: Route | Route[], skipRender?: boolean | null);
}

export function registerRoutes(
  router: KioskRouter,
  routeTree: Route[]
): KioskRouter {
  void router.setRoutes(routeTree);
  return router;
}

export function createRouter(element: HTMLElement): Router {
  return new Router(element);
}

// eslint-disable-next-line max-params
export function setupRouter(
  element: HTMLElement,
  routeTree: Route[],
  RouterClass: KioskRouter = Router,
  location: Location = window.location
) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const router: KioskRouter = new RouterClass(element);
  registerRoutes(router, routeTree);

  const prefix = process.env.URL_PATH_PREFIX ?? "";
  const { search, pathname } = location;
  const route = pathname.replace(prefix, "");
  if (route === "/") {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    RouterClass.go(`${prefix}/default/en/new-session${search}`);
  }
}

export { Router };
